/* eslint-disable max-len */
export const APP = {
  FONT: {
    FONT_FAMILY: {
      PRIMARY: 'Roboto-Regular'
    },
    FONT_COLOR: {
      PRIMARY: '#2ffc21',
      SECONDARY: ''
    },
    FONT_SIZE: {
      H1: 'clamp(2.625rem, 1.2857rem + 3.5714vw, 4rem)',
      H2: 'clamp(1.5rem, 0.9643rem + 1.4286vw, 2.25rem)',
      H3: '2.25rem',
      H4: '1.75rem',
      H5: '1.5rem',
      H6: '1.25rem',
      BUTTON: '0.875rem',
      SUBTITLE1: '1.125rem',
      BODY1: '1rem',
      BODY2: '0.875rem',
      CAPTION: '0.75rem',
      SUBTITLE2: '0.875rem',
      OVERLINE: '0.75rem'
    },
    FONT_WEIGHT: {
      H1: '800',
      H2: '800',
      H3: '400',
      H4: '400',
      H5: '400',
      H6: '500',
      BUTTON: '700',
      SUBTITLE1: '500',
      BODY1: '400',
      BODY2: '400',
      CAPTION: '700',
      SUBTITLE2: '500',
      OVERLINE: '400'
    }
  },
  LINE_HEIGHT: {
    H1: 1.1142857142857143,
    H2: 1.2222222222222223,
    H3: 1.2222222222222223,
    H4: 1.5,
    H5: 1.5,
    H6: 1.5,
    BUTTON: 1.75,
    SUBTITLE1: 1.3333333333333333,
    BODY1: 1.5,
    BODY2: 1.5,
    CAPTION: 1.5,
    SUBTITLE2: 1.57,
    OVERLINE: 2.66
  },
  PALETTE: {
    MODE: 'light' as const,
    PRIMARY: {
      MAIN: '#1976D2',
      LIGHT: '#66B2FF',
      DARK: '#0059B2',
      CONTRAST_TEXT: '#fff'
    },
    DIVIDER: '#E7EBF0',
    COMMON: {
      BLACK: '#1D1D1D',
      BLACK_SUB: '#1E1E1E',
      WHITE: '#fff',
      LIGHT_GRAY: '#E5E4E2',
      BORDER_GRAY_COLOR: '#D3D3D3'
    },
    TEXT: {
      PRIMARY: '#1A2027',
      SECONDARY: '#3E5060',
      DISABLED: 'rgba(0, 0, 0, 0.38)'
    },
    GREY: {
      SHADE_50: '#F3F6F9',
      SHADE_100: '#E7EBF0',
      SHADE_200: '#E0E3E7',
      SHADE_300: '#CDD2D7',
      SHADE_400: '#B2BAC2',
      SHADE_500: '#A0AAB4',
      SHADE_600: '#6F7E8C',
      SHADE_700: '#3E5060',
      SHADE_800: '#2D3843',
      SHADE_900: '#1A2027',
      SHADE_A100: '#f5f5f5',
      SHADE_A200: '#eeeeee',
      SHADE_A400: '#bdbdbd',
      SHADE_A700: '#616161',
      LIGHT_GRAY: '#D3D3D3'
    },
    ERROR: {
      MAIN: '#EB0014',
      LIGHT: '#ff99A2',
      DARK: '#C70011',
      CONTRAST_TEXT: '#fff'
    },
    SUCCESS: {
      MAIN: '#1AA251',
      DARK: '#1AA251',
      LIGHT: '#6AE79C',
      CONTRAST_TEXT: '#fff'
    },
    WARNING: {
      MAIN: '#DEA500',
      DARK: '#AB6800',
      LIGHT: '#FFDC48',
      CONTRAST_TEXT: '#fff'
    },
    SECONDARY: {
      MAIN: '#9c27b0',
      DARK: '#7b1fa2',
      LIGHT: '#ba68c8',
      CONTRAST_TEXT: 'rgba(0, 0, 0, 0.87)'
    },
    INFO: {
      MAIN: '#0288d1',
      DARK: '#01579b',
      LIGHT: '#03a9f4',
      CONTRAST_TEXT: '#fff'
    },
    CONTRAST_THRESHOLD: 3,
    TONAL_OFFSET: 0.2,
    BACKGROUND: {
      PAPER: '#fff',
      DEFAULT: '#fff',
      AUTO_LOGOUT: 'linen'
    },
    BOX_SHADOW: {
      MAIN: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
    },
    TABS: {
      MAIN: '#03A9F4',
      DARK: '#1976D2',
      PRIMARY: '#00BCD4',
      SECONDARY: ' #FF9800',
      DEFAULT: '#19D2B3',
      GRAY: '#1976D233',
      DISABLED: '#1976D20F'
    },
    CARDS: {
      LABEL: '#777',
      VALUE: '#4D4D4D'
    },
    ROLES: {
      RED: '#f44336',
      GRAY: '#616161',
      GRAY_1: '#9a9a9a',
      GRAY_2: '#a6a6a6',
      GREEN: '#4caf50'
    },
    USER_GROUP: {
      GRAY_1: '#9a9a9a',
      GRAY: '#616161',
      GRAY_2: '#a6a6a6'
    },
    DASHBOARD: {
      MAIN: '#1766B5'
    },
    APP_BAR_COLOR: {
      BACKGROUND:
        'linear-gradient(90deg, rgba(223,84,72,1) 0%, rgba(187,0,20,1) 4%, rgba(154,0,23,1) 7%, rgba(140,0,21,1) 9%, rgba(120,0,19,1) 12%, rgba(100,0,16,1) 20%, rgba(92,4,26,1) 34%, rgba(76,10,45,1) 53%, rgba(43,31,68,1) 80%, rgba(16,38,80,1) 100%)',
      INFO_CHIP: '#492b30'
    },
    SUB_MODULE_COLOR: {
      GRAY: '#616161',
      MAIN: '#492b30',
      BUTTON: '#18648A',
      HOVER_BUTTON: '#113052',
      BACKGROUND: '#F9F9F9',
      BACKGROUND2:"#1976D2",
      SECONDARY: '#391121',
      RED: '#FF6049',
      DISABLED_GRAY: '#D3D3D3',
      BLACK: '#000000',
      WHITE : "#FFFFFF"
    },
    MODULE_LAYOUT_COLOR: {
      MAIN: '#492b30',
      PRIMARY: '#113052',
      BUTTON: '#18648A',
      HOVER_BUTTON: '#113052',
      RED_BUTTON: '#FF6049',
      GREEN_BUTTON :'#008000',
      SECONDARY: '#114864',
      PROFILE_BACKGROUND: '#161d51',
      GRAY: '#808080'
    },
    PAGINATION_COLOR: {
      MAIN: '#492b30'
    },
    BADGE: {
      TEXT_COLOR: '#492B30',
      BACKGROUND: '#F5F5F5',
      BORDER_COLOR: '#FF6049'
    },
    DATA_GRID: {
      HEADER: '#F2F2F2',
      BOTTOM_BORDER: '#FF9081',
      BORDER_COLOR: '#FF6049'
    },
    CLINICAL_DOC: {
      BORDER_COLOR: 'rgb(205, 210, 215)',
      BACKGROUND_COLOR: 'rgba(181, 181, 181, 0.1)',
      FOLDER: 'rgba(0, 0, 0, 0.5)',
      CHECKBOX_OUTLINE: 'rgb(62, 80, 96)'
    },
    LOGIN: {
      BORDER_COLOR: '#7f7f7f',
      BOX_SHADOW_1: 'rgba(0, 0, 0, 0.25)',
      BOX_SHADOW_2: 'rgba(0, 0, 0, 0.22)',
      BUTTON: '#26648a',
      HOVER_BUTTON: '#113052',
      GRAY: '#808080',
      BUTTON_BACKGROUND: '#FFFFFF',
      BUTTON_COLOR: '#5E5E5E',
      BORDER: '#8C8C8C'
    },
    ABNORMAL_FLAG: {
      TEXT: '#FF0000'
    },
    CARD_COLOR:{
      LABEL:'#000',
      TEXT:'#0a0a0a'
    }
  }
};
